import { z } from "zod";
import type { ResponseGetCdtTree } from "./index";

export const RoutePutCdtTrees_treeId_ = "/cdt/trees/:treeId";

export const PutNodeSchema = z.object({
  id: z.number().int().positive().nullable(),
  parentNodeId: z.number().int().positive().nullable(),
  level: z.number().int().min(0).max(3),
  name: z.string().min(1).max(255).trim(),
  subdivisionField: z.string().nullable().optional(),
});

export const PutCdtTreeSchema = z.object({
  updatedAt: z.iso.datetime(),
  nodes: z.array(PutNodeSchema),
});

export type PutNode = z.infer<typeof PutNodeSchema>;
export type PutCdtTree = z.infer<typeof PutCdtTreeSchema>;
export type ResponsePutCdtTree = ResponseGetCdtTree;
